module.exports = __webpack_public_path__ + "img/rare-1-mob.abad8bd.webp";